import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import "@/index.css";
import App from "@/App";

const rootElement = document.getElementById("root");

// This is a client-rendered SPA (no SSR / react-snap prerendering), so always
// use createRoot. Using hydrateRoot here caused React #418 hydration errors
// whenever browser extensions injected nodes into #root before React mounted.
const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);
